import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthFetch } from './auth/installAuthFetch';

// Ancienne adresse Scalingo du front → adresse officielle, même page. Le cookie de session n'est
// jamais envoyé à l'API depuis l'ancienne adresse (autre site), qui ne permet donc pas de se
// connecter (AUTH_PLAN.md étape 4).
const LEGACY_HOSTS = { 'walter-front.osc-fr1.scalingo.io': 'https://walter.hydros-consulting.com' };
const canonicalOrigin = LEGACY_HOSTS[window.location.hostname];
if (canonicalOrigin) {
    window.location.replace(`${canonicalOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

// Avant tout rendu : chaque appel à l'API part avec le cookie de session.
installAuthFetch();

// Empêche le scroll de modifier la valeur des <input type="number"> focus
document.addEventListener('wheel', () => {
    if (document.activeElement instanceof HTMLInputElement && document.activeElement.type === 'number') {
        document.activeElement.blur();
    }
}, { passive: true });

if (!canonicalOrigin) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <App />
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
